import { useEffect } from 'react';
import { ElearningDataType } from '../types/elearning';
import { resolveAssetUrl, useIsMobileScreenSize } from '@/lib/util';

export function useModuleStyle(elearningData?: ElearningDataType) {
  const { isMobile } = useIsMobileScreenSize();

  useEffect(() => {
    if (!elearningData || !elearningData.bgImageName) return;

    const backgroundImage = resolveAssetUrl({
      assetBasePath: elearningData.assetBasePath,
      tenantId: `${elearningData.tenantId}`,
      entityId: `${elearningData.id}`,
      entity: 'elearnings',
      fileType: 'images',
      fileName: `${elearningData.bgImageName}`,
    });

    const ModuleStyleID = 'ModuleStyle';
    const stylePropertyPrefix = '#ModuleViewer';

    const ModuleStyleElement = document.getElementById(ModuleStyleID);
    if (ModuleStyleElement) {
      ModuleStyleElement.remove();
    }

    const style = document.createElement('style');
    style.setAttribute('id', ModuleStyleID);
    document.head.appendChild(style);
    const stylesheet = style.sheet;

    (stylesheet as CSSStyleSheet).insertRule(
      `${stylePropertyPrefix} #content-container {
          ${
            !isMobile
              ? `background: url("${backgroundImage}") repeat-y center;`
              : ''
          }
        }`,
      0,
    );
  }, [elearningData, elearningData?.bgImageName, isMobile]);

  return null;
}
